// @ts-nocheck
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";

import {
    chain,
    PopulateAddLineCollectionApiParameter,
    PopulateUpdateCartApiParameter,
} from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

addToChainAfter(chain, PopulateAddLineCollectionApiParameter, props => {
    const { apiParameter } = props;

    const fixedCartLines = apiParameter.cartLineCollection?.cartLines?.map(cartLine => {
        const fixedProperties = Object.entries(cartLine.properties).reduce<{ [key: string]: string }>(
            (acc, [key, value]) => {
                if (key === "overridePrice" || key === "overrideUnitOfMeasure") {
                    acc[key] = value;
                }
                return acc;
            },
            {},
        );
        return {
            ...cartLine,
            properties: fixedProperties,
        };
    });
    props.apiParameter.cartLineCollection.cartLines = fixedCartLines || [];
});

addToChainAfter(chain, PopulateUpdateCartApiParameter, props => {
    const state = props.getState();
    const order = props.parameter.order ?? getCartState(state, state.pages.savedOrderDetails.cartId).value;
    const existingProperties = props.updateCartApiParameter.cart.properties || {};
    props.updateCartApiParameter.cart.properties = {
        ...existingProperties,
        ...order?.properties,
    };
});
